Service = App.loadClass 'core::Angular/Service'

class exports.UndoService extends Service
    constructor: (@rootScope) ->
        @stack = []
        # we need the button name to add/remove classes
        @button_name = 'draw-undo'

    setDrawControl: (@drawControl) ->
        @updateButtonStatus()

    enable: () ->
        @drawControl.enableBtn(@button_name) if @drawControl?

    disable: () ->
        @drawControl.disableBtn(@button_name) if @drawControl?

    updateButtonStatus: () ->
        if @stack.length
            @enable()
        else
            @disable()

    undo: () =>
        # check for current and previous layers
        if @canUndo()
            @updateMap @getPreviousRemove()
            @updateButtonStatus()

    update: (@previous) =>
        # push the previous layer onto the stack
        @appendStack @previous
        # enable the button if needed
        @updateButtonStatus()

    appendStack: () ->
        # add an object to the stack
        @stack.push @previous

    getPreviousRemove: () ->
        # remove and return the last layer on the stack
        return @stack.pop()

    canUndo: () ->
        # check to ensure that we have all data needed for an undo
        return @previous? and @stack.length and @drawControl?

    cleanup: () ->
        @previous = null
        @stack = []
        @updateButtonStatus()

    updateMap: (layer) ->
        @drawControl._finishDrawing(layer, () =>
            @rootScope.$broadcast('mfdraw:apply')
        , false)
